<fui-edit-form-context>
    <fui-column [formGroup]="formGroup">
        <wbo-single-select-edit-control formControlName="actionType" [allowClearSelectionOption]="false"
                                        [(ngModel)]="orderAction.actionType">
            <wbo-order-action-type-select-options></wbo-order-action-type-select-options>
        </wbo-single-select-edit-control>
        <wbo-text-edit-control [(ngModel)]="orderAction.label"
                               formControlName="label"></wbo-text-edit-control>
        <ng-container formGroupName="qualifier">
            <wbo-meta-tag-single-select-edit-control *ngIf="orderAction.actionType === OrderActionType.DISPLAY_ORDER_READY"
                                                     [type]="MetaTagType.ORDER_READY_QUALIFIER"
                                                     [(ngModel)]="orderAction.qualifier.metaTagDefinitionId"
                                                     [objectValue]="orderAction.qualifier"
                                                     formControlName="metaTagDefinitionId"></wbo-meta-tag-single-select-edit-control>
        </ng-container>
        <fui-column *ngIf="orderAction.actionType === OrderActionType.PAGE_CUSTOMER"
                    [label]="'wbo.order-action-display.edit.field-set.messageSettings'">
            <wbo-text-edit-control [(ngModel)]="orderAction.description"
                                   formControlName="description"></wbo-text-edit-control>
            <wbo-text-edit-control [(ngModel)]="orderAction.location"
                                   formControlName="location"></wbo-text-edit-control>
            <wbo-textarea-edit-control class="notificationMessage"
                                       [label]="'wbo.order-action-display.edit.field.actions.notificationMessage.label'"
                                       [readonly]="true"
                                       [value]="notificationMessage | translate: {description: orderAction.description || '', location: orderAction.location}"></wbo-textarea-edit-control>
        </fui-column>
        <fui-column [label]="'wbo.order-action-display.edit.field-set.availableOrderTypes'">
            <fui-tandem-field>
                <wbo-checkbox-edit-control [(ngModel)]="orderAction.orderAhead"
                                           formControlName="orderAhead"></wbo-checkbox-edit-control>
                <wbo-checkbox-edit-control [(ngModel)]="orderAction.orderAtTable"
                                           formControlName="orderAtTable"></wbo-checkbox-edit-control>
            </fui-tandem-field>
        </fui-column>
        <wbo-checkbox-edit-control [(ngModel)]="orderAction.removeOrder"
                                   formControlName="removeOrder"></wbo-checkbox-edit-control>
    </fui-column>
</fui-edit-form-context>
